import {ItemType} from "../constants";

export interface IDirectoryContent {
    directories: string[],
    files: string[],
    category?: string[],
    token?: IContinuationToken
}

export interface IContinuationToken {
    nextMarker: string,
    targetLocation: number
}

export interface ISettings {
    [key: string]: string | boolean
}

export interface IFileDetails {
    availableResolutions: string[],
    properties: ISettings,
    fileName: string,
    length: number, // todo
    versions: IVersion[],
}

export interface IVersion {
    versionId: string
}

export enum DpasPopup {
    None,
    PictureDetail,
    UploadFile,
}

export interface IMasonryContent {
    id: number,
    name: string,
    src: string,
    type?: ItemType,
    folderType?: string,
}